import { Check } from "react-bootstrap-icons";
import "./Upload.css";

export function ModalSteps(props) {
  const step = props.step;
  const steps = ["Assign Contracts", "Review & Submit"];

  return (
    <div className="upload-steps">
      {steps.map(function (label, i) {
        const n = i + 1;
        const active = step === n;
        const done = step > n;

        const circleClass =
          "upload-steps__circle" +
          (active ? " is-active" : "") +
          (done ? " is-done" : "");

        return (
          <div key={n} style={{ display: "flex", alignItems: "center" }}>
            <div className="upload-steps__item">
              <div className={circleClass}>
                {done ? <Check size={13} /> : n}
              </div>
              <span
                className={"upload-steps__label" + (active ? " is-active" : "")}
              >
                {label}
              </span>
            </div>
            {i < steps.length - 1 && (
              <div
                className={"upload-steps__connector" + (done ? " is-done" : "")}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
